import { newImageModel as g } from "@ado/acs-standard-library";
import { LogoOption as d } from "./index.js";
const m = "/images/sprites/LdslateSprite.png", s = "/images/sprites/DL_Sprite.png", p = "/images/sprites/DoculawSlateSprite.png", u = "/images/sprites/RdSlateSprite.png", S = ({
  siteBrand: t,
  altCaption: e,
  hoverCaption: c,
  cssClass: r
}) => {
  let o, a = r;
  const n = t === void 0 ? "" : t.toLowerCase();
  switch (n) {
    case "rechtsdokumente":
      o = u;
      break;
    case "documentsl\xE9gaux":
      o = s;
      break;
    case "doculaw":
      o = p;
      break;
    default:
      o = m;
      break;
  }
  a = l(n, r);
  const i = g(
    o,
    e ?? `${t} Logo`,
    c
  );
  return new d(i, t, a);
}, l = (t, e) => {
  switch (t) {
    case "rechtsdokumente":
      return `${e === void 0 ? "" : e + "-"}rd-logo `;
    case "documentsl\xE9gaux":
      return `${e === void 0 ? "" : e + "-"}dl-logo `;
    case "doculaw":
      return `${e === void 0 ? "" : e + "-"}dlaw-logo `;
    default:
      return `${e === void 0 ? "" : e + "-"}ld-logo `;
  }
};
export {
  S as generateLogo
};
//# sourceMappingURL=index2.js.map
